<template>
    <div class="footer">      
      <div class="container">
        <div class="row footer-wrap">
          <div class="col-12 footer-link-container"> 
            <router-link to="/claimsguide">Help</router-link>            
            <router-link to="contact">Contact</router-link>            
            <a href="https://www.taurus.gi/privacy" target="_blank">Privacy</a>
          </div>          
        </div>      
        
        <div class="row">
          <div class="col-12">
            <slot name="main"></slot>
            <slot name="copyright"></slot>
          </div>
        </div>
      </div> 
      <div class="footer-svg-container"></div>     
    </div>
</template>

<script>

export default {
  name: 'PageFooterV2'
}
</script>
